<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Admission(reservation) process</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Determination and reservation for admission</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Delivery of SMS message about available time for hospitalization process and grades of patient's room (on the day of hospitalization)</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Administration process and ward entrance</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Determination and reservation for admission</h4>
            <p class="depth">For a patient whose admission has been decided as a result of medical check from the department or after an emergency medical service, the responsible/attending doctor in charge will input the date of hospitalization to the system.</p>
            <p class="depth">The patient and his/her guardian will then go through the admission process on the day or make a reservation at the hospitalization/discharge (emergency room) counter of the administration office.</p>
            <h4 class="depth bullet02">Delivery of information msg on admission process (on the day of hospitalization)</h4>
            <p class="depth">Once a room is allocated on the admission day, a kakaotalk message or a text message will be delivered, informing the time for admission process and the grades of rooms.</p>
            <p class="depth">A patient room will be determined based on the circumstances such as situation of the hospital on the day of hospitalization and discharged patients. Therefore, the patient may be allocated to a room with the grade which was not of the patient's highest priority on the day of admission.</p>
            <h4 class="depth bullet02">Administration process and ward entrance</h4>
            <p class="depth">On the day of hospitalization, the patient gets to visit the hospital with a guardian during the time indicated by the information message and fills out the inpatient agreement at hospitalization/discharge counter of the administration office.</p>
            <p class="depth">Upon completion of inpatient process, the patient moves to the ward where the room of the patient is located and the nurse in charge will guide the patient to the room.</p>
            <div class="table mt20">
                <table>
                    <colgroup>
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                        <col style="width: calc(100% / 3)">
                    </colgroup>
                    <thead>
                        <tr>
                            <th colspan="3">Supplies to be prepared at admission</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="left">
                                Personal items including toiletries, towels,<br class="pc-none"> cups, indoor shoes, toilet paper, etc. <br class="pc-none">and pillow and blanket, etc. for guardian
                            </td>
                            <td class="left">
                                <p>Medication taken before hospitalization</p>
                                <p class="bullet03">
                                    Medication taken before hospitalization, <br class="pc-none">please bring the medication and its subscription <br class="pc-none">if there is any that has been taken before hospitalization.<br class="pc-none"> The medication cannot be taken as one<br class="pc-none"> likes until the responsible/attending <br class="pc-none">doctor makes a decision.
                                </p>
                                <p class="bullet03">
                                    If necessary, the medicine can be replaced<br class="pc-none"> with other internally prescribed drug.
                                </p>
                            </td>
                            <td class="left">
                                Use of a humidifier, electric coffeepot, fan, <br class="pc-none">electric heater such as an electric blanket, <br class="pc-none">and inflammable/ignitable material is restricted<br class="pc-none"> to prevent infection, fire, and safety accident.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="mt10 font-sub">
                ※ For those who want a copy of written diagnosis, medical record, and/or a certificate at admission/discharge, please bring an ID. <br>
                (However, we require an ID of a guardian and a family relation certificate of immediate family (copy of family register) for minor patients under 14).
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Discharge information</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Determination of discharge</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Discharge training</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Insurance screening</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Payment</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">Receipt of medicine</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">Determination of discharge</h4>
            <p class="depth ">Final decision on discharge will be made by the responsible/attending doctor on the day or the day before.</p>
            <h4 class="depth bullet02 mt20">Discharge training</h4>
            <p class="depth ">Outpatient/hospitalization reservation further schedule including outpatient examination will be explained by the nurse and the nurse will organize the medical record.</p>
            <h4 class="depth bullet02 mt20">Insurance screening</h4>
            <p class="depth ">Once the insurance screening and medical record alignment are settled, the inspection team undergoes insurance review about the entered prescription.</p>
            <h4 class="depth bullet02 mt20">Payment</h4>
            <p class="depth ">After the insurance inspection team completes the payment review, an SMS message will be sent to the patient and the guardian. Then, the patient may make the payment at the hospitalization/discharge counter of the administration office or using a payment kiosk in the ward.</p>
            <h4 class="depth bullet02 mt20">Receipt of medicine</h4>
            <p class="depth ">Once the payment is completed, the nurse will explain a few things to be kept in mind including the medication before the patient returns home</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Interim payment of medical fee</h3>
            <h4 class="depth bullet02">Check and payment of interim medical fee</h4>
            <p class="depth">
                An interim payment of the medical fee can be checked and paid at the hospitalization/discharge counter of the administration office or using a payment kiosk in the ward. The amount that has been input to the computer up to a day before the day of check will be settled and shown (yet reviewed) so the figure may differ from the actual amount the patient needs to be paid at discharge.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>